import { render } from "./YoungUserCard.vue?vue&type=template&id=d4187b9e&scoped=true"
import script from "./YoungUserCard.vue?vue&type=script&lang=js"
export * from "./YoungUserCard.vue?vue&type=script&lang=js"

import "./YoungUserCard.vue?vue&type=style&index=0&id=d4187b9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4187b9e"]])

export default __exports__